export default __webpack_public_path__ + "static/0-5_HSR_Icon-62677714bbb866d1f3b11e782702ed01.png";